import { render, staticRenderFns } from "./levelDialog.vue?vue&type=template&id=05dda4c9&scoped=true&"
import script from "./levelDialog.vue?vue&type=script&lang=js&"
export * from "./levelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dda4c9",
  null
  
)

export default component.exports